import React, { useState, useEffect } from "react";
import MissionForm from "../../components/missions-component/MissionForm";
import { missionAPI } from '../../services/api';

function Missions() {
  const [showForm, setShowForm] = useState(false);
  const [missions, setMissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchMissions();
  }, []);

  const fetchMissions = async () => {
    try {
      const response = await missionAPI.getAll();
      console.log('Fetched missions:', response.data);
      setMissions(response.data);
    } catch (err) {
      console.error('Error fetching missions:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitSuccess = async (missionData) => {
    await fetchMissions(); // Refresh the missions list
    setShowForm(false);
  };

  if (loading) return <div>Loading missions...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="min-h-screen p-6 bg-gradient-to-b from-indigo-50 via-white to-indigo-100">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold">Missions</h1>
        <button
          onClick={() => setShowForm(true)}
          className="bg-indigo-600 text-white py-2 px-4 rounded hover:bg-indigo-700"
        >
          Create Mission
        </button>
      </div>

      {showForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold">Create New Mission</h2>
              <button
                onClick={() => setShowForm(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>
            <MissionForm onSubmitSuccess={handleSubmitSuccess} />
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 gap-6">
        {missions.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            No missions found. Create your first mission!
          </div>
        ) : (
          missions.map((mission) => (
            <div key={mission._id} className="border rounded-lg p-6 shadow-sm bg-white">
              <div className="flex justify-between items-start">
                <div>
                  <span className={`px-3 py-1 rounded-full text-sm font-medium
                    ${mission.type === 'Bug Bounties' ? 'bg-red-100 text-red-800' :
                    mission.type === 'Hackathons' ? 'bg-purple-100 text-purple-800' :
                    mission.type === 'RetroPGF' ? 'bg-green-100 text-green-800' :
                    'bg-blue-100 text-blue-800'}`}>
                    {mission.type}
                  </span>
                  <h3 className="text-xl font-semibold mt-2">{mission.title}</h3>
                  <div className="text-indigo-600 font-medium mt-1">
                    Funds: ${mission.amount}
                  </div>
                </div>
                <div className="flex gap-2">
                  <button className="bg-indigo-100 text-indigo-700 px-4 py-2 rounded hover:bg-indigo-200">
                    View Details
                  </button>
                  <button className="bg-green-100 text-green-700 px-4 py-2 rounded hover:bg-green-200">
                    Participate
                  </button>
                </div>
              </div>
              <p className="text-gray-600 mt-4">{mission.description}</p>
              {mission.kpis && mission.kpis.length > 0 && (
                <div className="mt-4">
                  <h4 className="font-medium mb-2">Key KPIs:</h4>
                  <ul className="list-disc list-inside text-gray-600">
                    {mission.kpis.map((kpi, idx) => (
                      <li key={idx}>{kpi}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default Missions;